import companyLogo from 'assets/funnel/power_serv.jpg';
import aiDisclaimer from 'assets/funnel/ai-disclaimer.png';
import handshakeImg from 'assets/funnel/hand_shake_lkw.png';

import heroImg from 'assets/funnel/thoni_915_1.jpg';
import infoHeroImg from 'assets/funnel/thoni_915_2.jpg';
import jobDetailsImg from 'assets/funnel/thoni_915_3.jpg';
import groupImg from 'assets/funnel/thoni_915_4.jpg';

const thoni_915 = {
  documentTitle: "Maschinenführer (m/w/d) mit Erfahrung im Bereich CNC | POWERSERV Austria GmbH",
  companyLogo,
  companyName: "POWERSERV Austria GmbH",
  aiDisclaimer,

  landing: {
    heroImg,
    chipText: "Vollzeit · €2.698 / Monat · Telfs",
    heroTitle: "Maschinenführer (m/w/d) · CNC",
    heroSubtitle: "CNC-Erfahrung gefragt – Maschinenführer:in bei einem führenden Industriebetrieb in Telfs / Pfaffenhofen.",
    facts: [
      { icon: 'bi-cash-stack',   title: '€ 2.698,59 / Monat',      subtitle: 'Brutto-Mindestlohn + Leistungsprämie' },
      { icon: 'bi-geo-alt-fill', title: 'Telfs / Pfaffenhofen',    subtitle: 'Standort · Tirol' },
      { icon: 'bi-clock',        title: '2-Schichtbetrieb',        subtitle: '05:30–13:30 & 13:30–21:30 Uhr' },
      { icon: 'bi-shield-check', title: 'Sicherer Arbeitsplatz',   subtitle: 'langfristige Perspektive' },
    ],
  },

  info: {
    heroImg: infoHeroImg,
    heroChip: "Vollzeit · CNC & Zerspanung",
    heroTitleLines: ["Maschinenführer", "(m/w/d)"],
    facts: [
      { value: "€ 2.698", label: "Brutto-Mindestlohn + Leistungsprämie" },
      { value: "Vollzeit", label: "Telfs / Pfaffenhofen" },
    ],
    moechtestDuItems: [
      { icon: 'bi-gear',          text: 'Fertigungsanlagen bedienen und dein Know-how im Bereich CNC und Zerspanung in einem modernen Industriebetrieb einsetzen?' },
      { icon: 'bi-search',        text: 'Störungen analysieren, beheben und durch laufende Qualitätskontrollen zur Produktqualität beitragen?' },
      { icon: 'bi-graph-up',      text: 'in einem dynamischen, international ausgerichteten Unternehmen langfristig Karriere machen und dich durch interne Weiterbildungen weiterentwickeln?' },
    ],
    benefits: [
      { icon: 'bi-shield-check',   title: 'Sicherer Arbeitsplatz',             desc: 'Unbefristete Vollzeitstelle mit langfristiger Perspektive in einem stabilen Unternehmen.' },
      { icon: 'bi-heart-pulse',    title: 'Gesundheitsangebote',               desc: 'Gesundheitsangebote und betriebsärztliche Betreuung vor Ort.' },
      { icon: 'bi-book',           title: 'Weiterentwicklung & Bildung',       desc: 'Weiterentwicklungs- und Bildungsmöglichkeiten durch interne Kompetenzerweiterung.' },
      { icon: 'bi-cup-hot',        title: 'Mittagsverpflegung & Essenszuschuss', desc: 'Mittagsverpflegung und Essenszuschuss inklusive.' },
      { icon: 'bi-globe',          title: 'Internationales Umfeld',            desc: 'Dynamisches Unternehmen mit internationaler Ausrichtung.' },
      { icon: 'bi-award',          title: 'Leistungsprämie',                  desc: 'Leistungsprämie zusätzlich zum Bruttolohn – noch nicht im Mindestlohn inkludiert.' },
    ],
    aufgabenTitle: "Präzision an der Maschine.",
    tasks: [
      'Bedienung von Fertigungsanlagen',
      'Fehleranalyse und Behebung von Störungen',
      'Durchführung laufender Qualitätskontrollen',
    ],
    requirements: [
      'Erfahrung im Bereich CNC und/oder Zerspanung',
      'Idealerweise abgeschlossene technische Ausbildung: Maschinenbautechnik, Metalltechnik oder vergleichbar – alternativ Berufserfahrung in einer ähnlichen Position',
      'Bereitschaft zur Schichtarbeit (Frühschicht: 05:30–13:30 Uhr, Spätschicht: 13:30–21:30 Uhr)',
      'Technisches Verständnis sowie Bereitschaft zur laufenden Weiterbildung',
    ],
    jobDetailsImg,
    jobDetailsTagLines: ["CNC &", "Zerspanung"],
    noteText: "Strukturierte und fundierte Einschulung in dein neues Aufgabengebiet – damit du vom ersten Tag an sicher und kompetent arbeitest.",
    groupImg,
    finalCtaTitle: "Dann bist du bei uns genau richtig!",
    finalCtaText: "Beantworte ein paar kurze Fragen – ganz ohne Lebenslauf und Anschreiben. Wir melden uns bei dir.",
  },

  quiz: {
    handshakeImg,
  },
};

export default thoni_915;
